<template>
  <div>
    <b-overlay :show="settingsLoading" class="rounded" variant="transparent">
      <template #overlay>
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
      </template>
      <div class="card shadow p-3">
        <div class="card-header border-0">
          <base-title :title="$t('settings')" popover="Listado de configuraciones sensibles"></base-title>
        </div>

        <b-row>
          <b-col md="2">
            <b-form-select
              v-model="filter.per_page"
              :options="[5, 10, 20, 100]"
              size="sm"
              class="mt-2"
              @input="debouncedGetAnswer()"
            ></b-form-select>
          </b-col>
          <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
            <b-form-group>
              <b-form-input
                class="form-control-sm"
                id="filter-input"
                v-model="filter.search"
                type="search"
                :placeholder="$t('search')"
                @input="debouncedGetAnswer()"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12" class="table-responsive">
            <b-table
              class="align-items-center table-flush tablesorter table-text"
              hover
              :items="getSettings.data"
              :fields="columns"
              :per-page="filter.per_page"
              :busy="
                !Array.isArray(getSettings.data) ||
                getSettings.data.length === 0
                  ? true
                  : false
              "
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <span class="h2 text-danger">{{ $t("fail") }}</span>
                </div>
              </template>

              <template v-slot:cell(created_at)="data">
                {{ moment(data.item.created_at).format("DD-MM-YYYY HH:mm") }}
                hrs.
              </template>

              <template v-slot:cell(actions)="data">
                <b-button
                  v-b-tooltip.hover
                  :title="$t('edit')"
                  variant="warning"
                  size="sm"
                  @click="$refs.created.show(data.item)"
                  ><i class="far fa-edit"></i
                ></b-button>
                <!-- <b-button
                  v-b-tooltip.hover
                  :title="$t('delete')"
                  variant="danger"
                  size="sm"
                  @click="deleteSetting(data.item.id)"
                  ><i class="far fa-trash-alt"></i
                ></b-button> -->
              </template>
            </b-table>
            <b-pagination
              class="mt-3"
              v-model="getSettings.current_page"
              :total-rows="getSettings.total"
              :per-page="getSettings.per_page"
              :page-count="getSettings.per_page"
              @input="changePage"
              first-number
              pills
              size="sm"
              align="center"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
    <CreatedOrUpdate ref="created" @refresh="syncData()" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
import moment from "moment";
import CreatedOrUpdate from "./createdOrUpdate.vue";
export default {
  components: {
    CreatedOrUpdate,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.syncData, 300);
    await this.syncData();
  },

  data() {
    return {
      filter: {
        per_page: 5,
        page: 1,
        search: null,
      },
      moment,
    };
  },

  methods: {
    ...mapActions({
      fetchSettings: "fetchSettings",
      settingsDelete: "settingsDelete",
    }),
    async syncData() {
      const { per_page, page, search } = this.filter;
      const payload = {
        per_page,
        page,
        search,
        paginated: true,
      };
      await this.fetchSettings(payload);
    },
    async changePage(value) {
      this.filter.page = value;
      await this.debouncedGetAnswer();
    },
    async deleteSetting(id) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t("question_delete_settings"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.settingsDelete(id);
            if (res.status === 200) {
              await this.syncData();

              this.$toast.success(res.message, {
                position: "top-right",
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getSettings: "getSettings",
      settingsLoading: "settingsLoading",
    }),
    columns() {
      return [
        { label: this.$t("key"), key: "key", class: "text-center" },
        { label: this.$t("value"), key: "value", class: "text-center" },
        { label: this.$t("created"), key: "created_at", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>